module.exports = __webpack_public_path__ + "media/images/logo_email-de1220cc632b5264258daa6b57c72c6a.png";